import { At802Plane } from "@/components/scoop-animation/At802Plane";

import "./SiteMaintenancePage.css";
import "@/components/scoop-animation/scoop-animation-shared.css";

function MaintenanceScoopAnimation() {
  return (
    <div className="scoop-scene maintenance-scoop-scene" aria-hidden="true">
      <svg
        className="scoop-svg maintenance-scoop-svg"
        viewBox="0 0 96 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect className="water-base" height="10" width="96" x="0" y="30" />
        <rect className="water-shine" height="1" width="96" x="0" y="30" />

        <g className="water-splash">
          <rect height="1" width="2" x="18" y="28" />
          <rect height="2" width="2" x="20" y="27" />
          <rect height="2" width="2" x="24" y="26" />
          <rect height="1" width="2" x="22" y="25" />
          <rect height="1" width="2" x="26" y="24" />
          <rect height="2" width="2" x="28" y="27" />
          <rect height="1" width="2" x="30" y="28" />
        </g>

        <g className="water-ripple">
          <rect className="ripple ripple-a" height="1" width="16" x="16" y="31" />
          <rect className="ripple ripple-b" height="1" width="20" x="14" y="32" />
        </g>

        <At802Plane />
      </svg>
    </div>
  );
}

export { MaintenanceScoopAnimation };
